import styled from 'styled-components';

import { SkeletonElement, breakpoints, theme } from '@notino/react-styleguide-v20';

export const StyledWrapper = styled.div`
  width: 100%;
  padding: 3rem 1rem;
  margin-bottom: 4rem;
  box-sizing: border-box;
  background-color: ${theme.color.background.disabled};
  @media (min-width: ${breakpoints.md}) {
    margin-bottom: 5rem;
    padding: 4rem 1rem;
  }
`;

export const StyledContainer = styled.div`
  margin: 0 auto;
  max-width: 65rem;
`;

export const StyledTitle = styled(SkeletonElement)`
  height: 2rem;
  width: 25rem;
  max-width: 100%;
  border-radius: 0.25rem;
  @media (min-width: ${breakpoints.md}) {
    height: 2.5rem;
  }
`;

export const StyledMessage = styled(SkeletonElement)`
  margin-top: 1rem;
  height: 1rem;
  width: 30rem;
  max-width: 100%;
  border-radius: 0.25rem;
`;
